var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$can('avance-forzar-edicion'))?_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Modificar")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }